module.exports = __webpack_public_path__ + "img/iconaccount.5cde4994.png";